import { head } from 'lodash';
import template from './statusSelectDialog.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $state, $mdDialog, $mdMedia, eventService, dateTimeService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.CurrentAccount = null;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.CurrentAccount = $rootScope.CurrentAccount;

        ctrl.destroyWatch = eventService.onDialogStatusSelect((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                statuses: params.statuses,
                selectedStatus: params.selectedStatus,
                data: params.data,
                account: ctrl.CurrentAccount
              },
              template,
              controllerAs: '$ctrl',
              controller(statuses, selectedStatus, data, account) {
                const ctr = this;
                ctr.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
                ctr.currentTimeZone = $rootScope.CurrentTimeZone();
                ctr.statuses = statuses;
                ctr.statusTimeStamp = dateTimeService.setDate(
                  moment.utc().tz(ctr.currentTimeZone).startOf('day'),
                  ctr.currentTimeZone
                );
                ctr.statusNote = '';
                ctr.selectedStatus = selectedStatus || head(statuses);
                ctr.data = data;
                ctr.account = account;

                ctr.confirm = () => {
                  $mdDialog.hide({
                    selectedStatus: {
                      status: ctr.selectedStatus,
                      statusDate: parseInt(
                        moment.utc(ctr.statusTimeStamp).startOf('day').format('X'),
                        10
                      ),
                      statusNote: ctr.statusNote
                    },
                    data: ctr.data
                  });
                };

                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              ctrl.onFinished({ selectedStatus: result.selectedStatus, data: result.data });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
